// extracted by mini-css-extract-plugin
export default {"discount-outlined-tag":"a3mj7_discount-outlined-tag","discount-bg":"slQDl_discount-bg","outlined-char":"K2SYL_outlined-char"};